

// import Vue from 'vue'


export const NotificationPlugin = {
  install(Vue) {
    Vue.prototype.$notify = function({
      // Status 
      error = false,
      success = false,
      warning = false,
      info = false,
      variant = null,

      // Content
      title = 'Error',
      message = 'Er is iets mis gegaan',
      text = null,

      // Position / group
      position = null,
      noAutoHide = false,
      delay = null
    }) {
      // Note that `danger` is default, and `error` also has highest priority
      variant = variant || 'danger'
      if (success) {
        variant = 'success'
      }
      if (info) {
        variant = 'info'
      }
      if (warning) {
        variant = 'warning'
      }
      if (error) {
        variant = 'danger'
      }

      const VueInstance = new Vue()

      // Bootstrap toast 
      // https://bootstrap-vue.org/docs/components/toast
      VueInstance.$bvToast.toast(text || message, {
        solid: true,
        toaster: position || 'b-toaster-top-right',
        title,
        variant,
        noAutoHide,
        autoHideDelay: delay || 5000 // ms
      })
    }
  }
}